import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import Link2 from '@mui/material/Link';

import NavItem from './components/NavItem';

const SidebarNav = ({ pages }) => {
  const theme = useTheme();
  const { mode } = theme.palette;

  const {
    landings: landingPages,
    secondary: secondaryPages,
    company: companyPages,
    account: accountPages,
    portfolio: portfolioPages,
    blog: blogPages,
  } = pages;

  return (
    <Box>
      <Box width={1} paddingX={2} paddingY={1}>
        <Box
          display={'flex'}
          component="a"
          href="/"
          title="theFront"
          width={{ xs: 80, md: 100 }}
        >
          <Box
            component={'img'}
            src={
              mode === 'light'
                  ? 'https://github.com/app-divaga/gobierno-web-Docs/blob/main/logovector.png?raw=true'
                  : 'https://github.com/app-divaga/gobierno-web-Docs/blob/main/logovector.png?raw=true'
            }
            height={1}
            width={1}
          />
        </Box>
      </Box>
      <Box paddingX={2} paddingY={2}>
        <Box>
          <Link2
              underline="none"
              component="a"
              href="https://gobierno.artesanostuxtepec.com/"
              color="text.primary"
          >
            Inicio
          </Link2>
        </Box>
        <br/>
        <Box>
          <Link2
              underline="none"
              component="a"
              href="/presupuesto-participativo"
              color="text.primary"
          >
            Presupuesto Participativo
          </Link2>
        </Box>
        <br/>

      </Box>
    </Box>
  );
};

SidebarNav.propTypes = {
  pages: PropTypes.object.isRequired,
};

export default SidebarNav;
